import { api } from "@/builders/axios";
import { ContentsData, CreateContent } from "@/builders/types/contents";

const get = function (id: number) {
  return api.get<ContentsData>(`/contents/${id}`).then(({ data }) => data);
};

const put = function (variables: { id: number; data: CreateContent }) {
  const { id, data } = variables;
  return api.put(`/contents/${id}`, data).then(({ data }) => data);
};

const patch = function (id: number, data: ContentsData) {
  return api.patch(`/contents/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/contents/${id}`);
};

export const id = {
  get,
  put,
  patch,
  del,
};
